export default "__VITE_ASSET__C5tlCNW3__"